module.exports = __webpack_public_path__ + "img/bankcode3.6e977e74.png";